'use client';

import Section from '../molecules/section';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useState } from 'react';
import Image from 'next/image';

const FaqsSection = () => {
  const t = useTranslations('FAQs');
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    { title: t('questions.question-1.title'), content: t.raw('questions.question-1.content') },
    { title: t('questions.question-2.title'), content: t.raw('questions.question-2.content') },
    { title: t('questions.question-3.title'), content: t.raw('questions.question-3.content') },
    { title: t('questions.question-4.title'), content: t.raw('questions.question-4.content') },
    { title: t('questions.question-5.title'), content: t.raw('questions.question-5.content') },
    { title: t('questions.question-6.title'), content: t.raw('questions.question-6.content') },
    { title: t('questions.question-7.title'), content: t.raw('questions.question-7.content') },
  ];

  return (
    <Section
      id="faqs"
      backgroundImage="/images/FAQ.avif"
      className="relative flex min-h-screen items-center justify-center bg-no-repeat bg-cover"
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black opacity-50"></div>

      {/* Top gradient */}
      <div className="absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-black to-transparent"></div>

      {/* Bottom gradient */}
      <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-black to-transparent"></div>

      <div className="relative px-10 pb-80 pt-44">
        <div className="flex flex-col items-center justify-center gap-8 mb-8">
          <h2 className="text-center text-3xl font-bold text-white md:text-5xl font-sora uppercase">
            {t('title')}
          </h2>
          <div className='flex flex-col w-[90%]'>
            <p className="font-sora text-lg font-semibold leading-7 text-center text-white w-full">
              {t('sub-title')}
            </p>
            <p className="font-sora text-lg font-semibold leading-7 text-center text-white w-full">
              {t('sub-title2')}
            </p>
          </div>

          <div className="w-full max-w-3xl space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-black/50 border-neutral-700 backdrop-blur-md rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full px-6 py-4 flex items-center justify-between text-left"
                >
                  <h3 className="text-white font-sora text-base font-normal leading-[1.4] pr-4 custom-font-features">
                    {faq.title}
                  </h3>
                  {openIndex === index ? <Image src={'/images/chevron-up-gray.png'} alt="Selected Icon" width={25} height={25} /> : <Image src={'/images/chevron-down-gray.png'} alt="Selected Icon" width={25} height={25} />}
                </button>

                <div
                  className={`transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    } overflow-hidden`}
                >
                  <div className="px-6 pb-4">
                    <p
                      className="text-white font-sora text-xs font-normal leading-[1.6]"
                      dangerouslySetInnerHTML={{ __html: faq.content }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className='flex flex-col space-y-4'>
          <div className='flex flex-row items-center justify-center'>
            <Link
              href={`https://docs.shib.io/docs/playwithshib/metaverse/intro`}
              target='_blank'
              className="w-full sm:px-16 md:px-10 lg:px-10 py-2.5 sm:w-[60%] md:w-[40%] lg:w-[25%] flex items-center justify-center rounded-full border border-[#F17E0E] bg-[#F38F2E] text-center text-xs md:text-sm font-medium text-white"
            >
              {t('intro-docs-btn')}
            </Link>
          </div>
          <div className='flex flex-row items-center justify-center'>
            <Link
              href={`https://docs.shib.io/docs/playwithshib/metaverse/faq`}
              target='_blank'
              className="w-full md:w-[40%] lg:w-[25%] sm:px-16 md:px-10 lg:px-10 py-2.5 flex items-center justify-center rounded-full border border-[#404040] bg-black/50 text-center text-xs md:text-sm font-medium text-white shadow-[0px_2px_4px_0_rgba(0,0,0,0.4)] backdrop-blur-[24px]"
            >
              {t('faq-docs-btn')}
            </Link>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default FaqsSection;